<template>
  <div>
    <CreateNewNotificationDialog
      :dialog="showCreateNewNotificationDialog"
      :startDate="new Date().toISOString().substr(0, 10)"
      :endDate="new Date().toISOString().substr(0, 10)"
      @close="closeCreateNewNotificationDialog"
    >
    </CreateNewNotificationDialog>

    <v-card>
      <v-toolbar
        color="light-green"
      >
        <v-toolbar-title>
          Notifications
        </v-toolbar-title>
      </v-toolbar>

      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, }"
        :headers="headers"
        :loading="busy"
        :items="notifications"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
      </v-data-table>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          @click.stop="openCreateNewNotificationDialog()"
        >
          Create Notification
        </v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import CreateNewNotificationDialog from '../components/push_notifications/CreateNewNotificationDialog.vue';

export default {
  components: {
    CreateNewNotificationDialog,
  },

  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name',
          width: 100,
        },
        {
          text: 'Path',
          align: 'left',
          sortable: false,
          value: 'resourcePath',
          width: 200,
        },
        {
          text: 'MIME Type',
          align: 'left',
          sortable: false,
          value: 'mimeType',
          width: 100,
        },
        {
          text: 'Begins',
          align: 'left',
          sortable: false,
          value: 'beginsOn',
          width: 100,
        },
        {
          text: 'Ends',
          align: 'left',
          sortable: false,
          value: 'endsOn',
          width: 100,
        },
        {
          text: 'Target Type',
          align: 'left',
          sortable: false,
          value: 'targetType',
          width: 100,
        },
      ],

      options: {},
      busy: false,
      serverItemsLength: 0,
      notifications: [],
      showCreateNewNotificationDialog: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/read/notifications/v1/?page=${this.options.page || 1}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.notifications = res.data.docs;
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    openCreateNewNotificationDialog() {
      this.showCreateNewNotificationDialog = true;
    },

    closeCreateNewNotificationDialog(data) {
      if (data) {
        this.busy = true;

        const options = {
          method: 'post',
          url: '/create/notification/v1/',
          data,
        };

        this.axios(options)
          .then((res) => {
            this.showCreateNewNotificationDialog = false;
            this.busy = false;
            this.getData();
          })
          .catch((err) => {
            this.showCreateNewNotificationDialog = false;
            this.busy = false;
          });
      } else {
        this.busy = false;
        this.showCreateNewNotificationDialog = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
